// Exact presentation exception for a verified visible malformed headline.
// Keep the source DTO and stored title unchanged; do not infer repeated halves.
const LUMA_HEADLINE = 'Responsive Architectural Presentations with AI'
const LUMA_DUPLICATED_HEADLINE = `${LUMA_HEADLINE}${LUMA_HEADLINE}`

export const portfolioNewsDisplayTitle = (title: string): string =>
  title === LUMA_DUPLICATED_HEADLINE ? LUMA_HEADLINE : title
